import { useContext, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import EnterPassword from './sections/EnterPassword/EnterPassword';
import LoginCard from './sections/LoginCard/LoginCard';
import Footer from '../../../shared/components/Globals/Footer/Footer';
import Toast from '../../../shared/components/Globals/Toast/Toast';
import { SIGN_UP_ROUTE } from '../../../shared/constants/auth';
import { LOGIN_ERROR_TOAST } from '../../../shared/constants/toast';
import { AuthContext } from '../../../shared/hooks/useAuth/useAuth';
import Users from '../../../shared/services/api/users/users';

const Login = () => {
  const [email, setEmail] = useState('');
  const [step, setStep] = useState(0);
  const [errorToast, setErrorToast] = useState(false);

  const { resetError } = useContext(AuthContext);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const changeEmail = async (userEmail: string) => {
    resetError('');
    setEmail(userEmail);
    try {
      const response = await Users.checkEmail(userEmail);
      if (response.verified) {
        setStep(1);
        return;
      }
      navigate(SIGN_UP_ROUTE, { state: { email: userEmail } });
    } catch {
      setErrorToast(true);
    }
  };

  const handleChangeStep = (newStep: number) => {
    setStep(newStep);
  };

  const handleCloseErrorToast = () => {
    setErrorToast(false);
  };

  return (
    <>
      <div className="auth__container">
        {step === 0 && <LoginCard changeEmail={changeEmail} />}
        {step === 1 && <EnterPassword email={email} changeStep={handleChangeStep} />}
        <Toast
          message={t(LOGIN_ERROR_TOAST.message)}
          variant={LOGIN_ERROR_TOAST.variant}
          open={errorToast}
          onClose={handleCloseErrorToast}
        />
      </div>
      <Footer isAuthenticated={false} />
    </>
  );
};

export default Login;
